import { Component, OnInit, Input } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { TdLoadingService } from '@covalent/core';

import { AdminService } from '../../../../services/admin/admin.service';
import { PetitionsAmount } from '../../../../shared/admin-models/interfaces/petitions-amount.interface';

@Component({
  selector: 'app-admin-navigation',
  templateUrl: './admin-navigation.component.html',
  styleUrls: ['./admin-navigation.component.scss']
})
export class AdminNavigationComponent implements OnInit {
  @Input() section: string;
  constructor(
    private _loadingService: TdLoadingService,
    private _snackBar: MatSnackBar,
    public adminService: AdminService
  ) {}
  petitionsAmount: PetitionsAmount[];
  petitionsGroups = {
    ideaAgreed: {
      statuses: [14, 15, -14],
      amount: 0
    },
    ideaAll: {
      statuses: [],
      amount: 0
    },
    ideaBlocked: {
      statuses: [4, 5],
      amount: 0
    },
    ideaCompleted: {
      statuses: [6, -6],
      amount: 0
    },
    ideaCurrent: {
      statuses: [3, -3],
      amount: 0
    },
    ideaDefected: {
      statuses: [11, -11],
      amount: 0
    },
    ideaFailed: {
      statuses: [7],
      amount: 0
    },
    ideaInDiscuss: {
      statuses: [8, -8, 13, -13, 14, -14, 16, -16],
      amount: 0
    },
    ideaInDiscussion: {
      statuses: [8, -8, 13, -13, 14, -14, 16, -16],
      amount: 0
    },
    ideaMyArchive: {
      statuses: [15, -15, 17, -17],
      amount: 0
    },
    ideaNew: {
      statuses: [2, 12, -2, -12],
      amount: 0
    },
    ideaRejected: {
      statuses: [9, 10, 16, 17, -9, -16],
      amount: 0
    },
    ideaResponse: {
      statuses: [8, -8],
      amount: 0
    },
    ideaResponseMode: {
      statuses: [2, 9, 12, 14, 16, -2, -9, -12, -14, -16],
      amount: 0
    },
    ideaSentDiscuss: {
      statuses: [8, -8],
      amount: 0
    },
    ideaWaitDecision: {
      statuses: [6, 13, -6, -13],
      amount: 0
    }
  };
  ngOnInit() {
    this.getPetitionsAmount();
  }
  get isConfigurationsAdmin() {
    return this.adminService.isConfigurationsAdmin;
  }
  getPetitionsAmount() {
    this._loadingService.register();
    this.adminService.getPetitionsAmountByStatuses().subscribe(
      (res: PetitionsAmount[]) => {
        this._loadingService.resolve();
        this.petitionsAmount = res;
        if (res && res.length) {
          for (const key in this.petitionsGroups) {
          }
        }
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  givePetitionsAmount(petitionName: string): number {
    var result = 0;
    if (this.petitionsGroups[petitionName]) {
      if (petitionName === 'ideaAll') {
        if (this.petitionsAmount && this.petitionsAmount.length) {
          this.petitionsAmount.forEach((element) => {
            result += element.count;
          });
        }
      } else {
        if (this.petitionsAmount && this.petitionsAmount.length) {
          this.petitionsAmount.forEach((element) => {
            if (
              this.petitionsGroups[petitionName].statuses.find(
                (e) => e === element.statusId
              )
            ) {
              result += element.count;
            }
          });
        }
      }
    }
    return result;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/admin-navigation/admin-navigation.component.ts